import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicab() {



  const cardData = {




keyword: "Pune to Shirdi Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Shirdi Cab Service for devotees, families, senior citizens, couples, and groups planning a convenient pilgrimage to Shirdi. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way journeys, round trips, Sai Baba Darshan, and customized religious travel plans. With experienced drivers, clean and well-maintained vehicles, flexible pickup locations across Pune, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make the journey smooth and comfortable. Travelers can also combine Shirdi with nearby religious and sightseeing destinations for a complete pilgrimage itinerary.",

topPlaces: [
  {
    title: "Shirdi",
    description: "Shirdi is one of Maharashtra's most important pilgrimage destinations and attracts devotees throughout the year for Sai Baba Darshan. Families, senior citizens, and groups traveling from Pune can choose a private cab for comfortable door-to-door transportation and flexible travel timings. Garud Cab Service provides spacious vehicles suitable for both one-way and round-trip Shirdi journeys."
  },
  {
    title: "Sai Baba Temple",
    description: "Sai Baba Temple, also known as Shri Saibaba Sansthan Temple, is the main spiritual attraction in Shirdi and welcomes devotees from across India. Visitors come to offer prayers and seek blessings at the sacred temple complex. A chauffeur-driven cab from Pune provides convenient transportation for families and groups planning their Darshan."
  },
  {
    title: "Dwarkamai",
    description: "Dwarkamai is one of the most significant spiritual places in Shirdi and is closely associated with the life of Sai Baba. The historic site holds great importance for devotees visiting the town and is generally included in a Shirdi pilgrimage itinerary. Travelers can conveniently visit Dwarkamai along with other nearby spiritual attractions using a private cab."
  },
  {
    title: "Chavadi",
    description: "Chavadi is an important religious site in Shirdi connected with Sai Baba's life and traditions. It is located close to the main temple area and is visited by devotees as part of their spiritual journey. Garud Cab Service offers comfortable transportation for passengers who want to explore the major religious landmarks around Shirdi."
  },
  {
    title: "Khandoba Temple",
    description: "Khandoba Temple is a historic temple in Shirdi associated with Lord Khandoba and is regarded as an important part of the town's religious heritage. It is a convenient stop for devotees exploring Shirdi beyond the main Sai Baba Temple. Families traveling from Pune can include the temple in their customized pilgrimage itinerary."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a famous religious destination dedicated to Lord Shani and is located within the broader Shirdi pilgrimage region. Devotees often combine Shirdi and Shani Shingnapur in the same journey. A private cab from Pune makes it easier to visit both destinations with flexible timings and convenient transportation."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a major pilgrimage destination near Nashik and is home to the revered Trimbakeshwar Jyotirlinga Temple. Travelers planning an extended religious tour from Pune can combine Trimbakeshwar with Shirdi for a multi-temple journey. Garud Cab Service provides comfortable vehicles for families and groups traveling between these destinations."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious and cultural city known for Panchavati, sacred temples, Godavari ghats, and access to Trimbakeshwar. It can be included in a longer Pune to Shirdi pilgrimage itinerary for additional sightseeing and religious visits. A private cab gives travelers flexibility to explore Nashik before or after their Shirdi Darshan."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are a renowned heritage attraction near Aurangabad featuring remarkable Buddhist, Hindu, and Jain rock-cut monuments. The Kailasa Temple is particularly famous for its extraordinary ancient architecture. Travelers planning a multi-day religious trip from Pune can combine Shirdi with Ellora and other nearby attractions."
  },
  {
    title: "Grishneshwar",
    description: "Grishneshwar is a revered Jyotirlinga pilgrimage destination located close to Ellora Caves. The temple is dedicated to Lord Shiva and attracts devotees throughout the year. Travelers looking for an extended religious journey can include Grishneshwar along with Shirdi, while Garud Cab Service provides comfortable chauffeur-driven transportation for the complete itinerary."
  }
],




"services": [
{
"name": "Pune to Shirdi Taxi",
"description": "Book Pune to Shirdi Taxi for a comfortable and convenient pilgrimage journey with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for Sai Baba darshan, family trips, religious travel, sightseeing, one-way transfers, and round-trip journeys."
},
{
"name": "Pune to Shirdi Cab Package",
"description": "Choose Pune to Shirdi Cab Package for a convenient private journey planned according to your travel schedule and darshan requirements. Enjoy comfortable AC transportation, professional chauffeur service, flexible pickup, spacious luggage capacity, and suitable vehicle options for families, senior passengers, couples, and groups visiting Shirdi."
},
{
"name": "Pune to Shirdi Cab Charges",
"description": "Get Pune to Shirdi Cab Charges according to your selected vehicle, journey type, passenger count, and travel requirements. Choose from economical Sedan and Swift Dzire cars or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for comfortable one-way, round-trip, pilgrimage, and sightseeing travel."
},
{
"name": "Pune to Shirdi Cab Fare",
"description": "Check Pune to Shirdi Cab Fare before booking and select a vehicle that matches your budget, passenger capacity, luggage requirements, and comfort preferences. Enjoy private chauffeur-driven AC transportation with flexible options for family trips, Sai Baba darshan, religious tours, personal visits, and planned outstation journeys."
},
{
"name": "Pune to Shirdi Cab One Way",
"description": "Book Pune to Shirdi Cab One Way for a direct point-to-point journey without arranging a return trip. Enjoy convenient pickup from your home, office, hotel, or other location in Pune with professional chauffeur service, comfortable AC vehicles, and suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options."
},
{
"name": "Pune to Shirdi Taxi Fare",
"description": "Get Pune to Shirdi Taxi Fare information with flexible vehicle choices for individual travelers, families, senior citizens, and groups. Select an economical sedan or spacious Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your passenger count, luggage needs, journey type, and preferred travel comfort."
},
{
"name": "Pune to Shirdi Cab Service",
"description": "Choose Pune to Shirdi Cab Service for reliable and comfortable outstation transportation with experienced chauffeurs, clean AC vehicles, and convenient door-to-door pickup and drop facilities. The service is suitable for Sai Baba darshan, family pilgrimages, religious tours, weekend travel, sightseeing, and personal journeys."
},
{
"name": "Pune to Shirdi Cab Booking Service",
"description": "Make Pune to Shirdi Cab Booking Service for a scheduled and private journey with convenient pickup arrangements and direct destination drop. Select your preferred vehicle according to passenger capacity, luggage requirements, travel date, and journey type while enjoying professional chauffeur service and comfortable AC transportation."
},
{
"name": "Pune to Shirdi Taxi Drop",
"description": "Hire Pune to Shirdi Taxi Drop for a direct and hassle-free transfer to your preferred hotel, temple area, accommodation, or other destination in Shirdi. Professional chauffeurs provide comfortable AC travel with convenient pickup from Pune and suitable vehicle options for individuals, families, senior passengers, and groups."
},
{
"name": "Pune Airport to Shirdi Cab",
"description": "Reserve Pune Airport to Shirdi Cab for convenient airport pickup and direct transportation from Pune Airport to Shirdi. Professional chauffeurs can assist with luggage while providing a comfortable ride in clean AC vehicles, making the service suitable for pilgrims, families, tourists, business travelers, and passengers arriving in Pune for onward travel."
},
{
"name": "Pune to Shirdi Car Rental",
"description": "Book Pune to Shirdi Car Rental with a professional chauffeur for comfortable and stress-free intercity transportation. Choose an economical sedan, spacious Ertiga, family-friendly Innova, premium Innova Crysta, Kia Carens, or SUV according to your group size, luggage capacity, travel duration, and pilgrimage requirements."
},
{
"name": "Pune to Shirdi Cab Booking",
"description": "Reserve Pune to Shirdi Cab Booking for a convenient private journey with scheduled pickup and direct drop facilities. Plan your travel according to your preferred date and timing while selecting a suitable Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV for family, religious, and personal travel."
},
{
"name": "Pune to Shirdi Cab Price",
"description": "Find a competitive Pune to Shirdi Cab Price with multiple vehicle categories available for different passenger and luggage requirements. Choose from economical sedans or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles for comfortable chauffeur-driven travel to Shirdi for darshan, sightseeing, family visits, and religious journeys."
},
{
"name": "Pune to Shirdi Car",
"description": "Hire a Pune to Shirdi Car for private and comfortable travel with an experienced chauffeur and well-maintained AC interiors. Select a vehicle according to your group size and luggage requirements while enjoying convenient pickup, spacious seating, flexible travel arrangements, and direct transportation to Shirdi."
},
{
"name": "Cab Service from Pune to Shirdi",
"description": "Book Cab Service from Pune to Shirdi for dependable pilgrimage and outstation transportation with trained chauffeurs and comfortable AC vehicles. Flexible pickup locations and vehicle choices make the service suitable for Sai Baba devotees, families, senior passengers, tourists, couples, and groups planning one-way or round-trip travel."
},
{
"name": "Pune to Shirdi Cab Booking Rates",
"description": "Check Pune to Shirdi Cab Booking Rates according to the selected vehicle category, journey type, passenger count, and travel requirements. Choose Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for comfortable private transportation and planned one-way or return journeys."
},
{
"name": "Pune Airport to Shirdi Taxi",
"description": "Choose Pune Airport to Shirdi Taxi for direct airport-to-Shirdi transportation with convenient pickup, luggage assistance, professional chauffeurs, and comfortable AC vehicles. The service is suitable for pilgrims arriving by air, families, senior travelers, corporate visitors, tourists, and passengers continuing their journey to Shirdi."
},
{
"name": "Pune to Shirdi Cab Service Rates",
"description": "Get Pune to Shirdi Cab Service Rates based on your preferred vehicle, travel plan, passenger requirements, and journey duration. Select economical Sedan and Swift Dzire cars or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for pilgrimage trips, family travel, sightseeing, and outstation transportation."
},
{
"name": "Pune to Shirdi Package by Car",
"description": "Book Pune to Shirdi Package by Car for a convenient pilgrimage journey with private chauffeur-driven transportation and flexible travel arrangements. Choose a suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV for Sai Baba darshan, family travel, sightseeing, and planned return journeys."
},
{
"name": "Pune to Shirdi Cabs Round Trip",
"description": "Reserve Pune to Shirdi Cabs Round Trip for convenient return transportation according to your darshan and sightseeing schedule. Enjoy private AC travel, experienced chauffeur service, spacious luggage capacity, and flexible vehicle options suitable for families, groups, senior passengers, and devotees planning a same-day or extended pilgrimage."
},
{
"name": "Pune Airport to Shirdi Cab Price",
"description": "Check Pune Airport to Shirdi Cab Price according to your selected vehicle and passenger requirements. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles for comfortable airport pickup, luggage-friendly travel, professional chauffeur service, and direct transportation to Shirdi."
},
{
"name": "Pune Airport to Shirdi Airport",
"description": "Arrange Pune Airport to Shirdi Airport transportation for convenient travel planning between Pune Airport and the Shirdi region. Enjoy private chauffeur-driven AC transportation with suitable vehicle choices for passengers carrying luggage and travelers requiring a comfortable onward transfer for pilgrimage, business, or personal purposes."
},
{
"name": "Pune Airport to Shirdi Cab Fare",
"description": "Get Pune Airport to Shirdi Cab Fare information with flexible vehicle options for individuals, families, pilgrims, and groups. Select an economical sedan or spacious Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to passenger count, luggage requirements, and preferred level of comfort."
},
{
"name": "Pune Airport to Shirdi Cab Service",
"description": "Book Pune Airport to Shirdi Cab Service for reliable airport pickup and direct transportation to your destination in Shirdi. Professional chauffeurs provide comfortable AC travel, convenient luggage handling, scheduled pickup arrangements, and suitable vehicle options for families, tourists, pilgrims, corporate passengers, and groups."
},
{
"name": "Pune to Shirdi Cab Cost",
"description": "Check Pune to Shirdi Cab Cost according to your vehicle category, passenger count, journey type, and travel requirements. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for private chauffeur-driven transportation suitable for one-way drops, round trips, darshan, and sightseeing."
},
{
"name": "Pune to Shirdi Car Package",
"description": "Choose Pune to Shirdi Car Package for a comfortable pilgrimage trip with private transportation and flexible travel arrangements. Select a vehicle according to your group size and enjoy professional chauffeur service, AC interiors, spacious seating, convenient pickup, and suitable options for Sai Baba darshan and family journeys."
},
{
"name": "Pune to Shirdi Taxi Charges",
"description": "Find Pune to Shirdi Taxi Charges according to your selected vehicle and travel requirements. Choose economical Sedan and Swift Dzire cars or larger Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles for comfortable religious tours, family travel, sightseeing, one-way transfers, and round-trip journeys."
},
{
"name": "Shirdi Pune Cab",
"description": "Book Shirdi Pune Cab for a comfortable return journey from Shirdi to Pune with professional chauffeurs and well-maintained AC vehicles. Pickup can be arranged from hotels, accommodation, temple areas, or other locations in Shirdi, making the service suitable for pilgrims, families, senior passengers, tourists, and groups."
},
{
"name": "Taxi Service from Pune to Shirdi",
"description": "Choose Taxi Service from Pune to Shirdi for dependable private transportation with experienced chauffeurs, comfortable AC vehicles, and convenient pickup and drop arrangements. The service is suitable for Sai Baba devotees, family pilgrimages, senior travelers, tourists, couples, corporate passengers, and groups planning one-way or round-trip journeys."
}
],
"tableData": [
["Pune to Shirdi Taxi", "Pune to Shirdi Cab Package"],
["Pune to Shirdi Cab Charges", "Pune to Shirdi Cab Fare"],
["Pune to Shirdi Cab One Way", "Pune to Shirdi Taxi Fare"],
["Pune to Shirdi Cab Service", "Pune to Shirdi Cab Booking Service"],
["Pune to Shirdi Taxi Drop", "Pune Airport to Shirdi Cab"],
["Pune to Shirdi Car Rental", "Pune to Shirdi Cab Booking"],
["Pune to Shirdi Cab Price", "Pune to Shirdi Car"],
["Cab Service from Pune to Shirdi", "Pune to Shirdi Cab Booking Rates"],
["Pune Airport to Shirdi Taxi", "Pune to Shirdi Cab Service Rates"],
["Pune to Shirdi Package by Car", "Pune to Shirdi Cabs Round Trip"],
["Pune Airport to Shirdi Cab Price", "Pune Airport to Shirdi Airport"],
["Pune Airport to Shirdi Cab Fare", "Pune Airport to Shirdi Cab Service"],
["Pune to Shirdi Cab Cost", "Pune to Shirdi Car Package"],
["Pune to Shirdi Taxi Charges", "Shirdi Pune Cab"],
["Taxi Service from Pune to Shirdi", ""]
]
,



whychoose: [
  {
    WhyChooseheading: "Pune to Shirdi Cab for a Comfortable Sai Darshan Trip",
    WhyChoosedescription: "Garud Cab Service provides private Pune to Shirdi cabs for devotees, families, senior citizens, couples, and groups looking for convenient transportation to Shirdi for Sai Baba darshan and religious travel."
  },
  {
    WhyChooseheading: "Direct Travel from Pune to Shirdi",
    WhyChoosedescription: "Travel directly from your preferred pickup point in Pune to Shirdi without changing vehicles, making the journey convenient for families, elderly passengers, and travellers carrying luggage."
  },
  {
    WhyChooseheading: "One-Way, Return & Same-Day Options",
    WhyChoosedescription: "Choose a one-way cab when you only need a drop to Shirdi, or arrange a round-trip or same-day return according to your darshan plans and preferred schedule."
  },
  {
    WhyChooseheading: "Comfortable for Senior Citizens",
    WhyChoosedescription: "Private cab travel can make a pilgrimage easier for elderly devotees by providing direct transportation, comfortable seating, convenient pickup, and the flexibility to plan rest breaks."
  },
  {
    WhyChooseheading: "Family-Friendly Sai Baba Pilgrimage",
    WhyChoosedescription: "Families can travel together in a dedicated vehicle and select an option based on passenger count, luggage, and comfort requirements for their Shirdi visit."
  },
  {
    WhyChooseheading: "Convenient Pune Pickup Service",
    WhyChoosedescription: "Arrange pickup from your home, hotel, office, residential society, railway station area, or another preferred location in Pune for a hassle-free start to your religious journey."
  },
  {
    WhyChooseheading: "Add Nearby Religious Destinations",
    WhyChoosedescription: "If you have additional time, the itinerary can be planned to include nearby religious or sightseeing destinations along with your Shirdi visit, depending on the selected route."
  },
  {
    WhyChooseheading: "Book Your Shirdi Journey with Garud",
    WhyChoosedescription: "Share your Pune pickup location, travel date, passenger count, preferred vehicle, darshan schedule, and return requirement with Garud Cab Service to arrange a suitable Shirdi cab."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Shirdi Cab Service?",
    answer: "Yes, Garud Cab Service provides Pune to Shirdi cabs for Sai Baba darshan, religious trips, family travel, senior citizens, and devotee groups."
  },
  {
    question: "Can I book a one-way cab from Pune to Shirdi?",
    answer: "Yes, one-way cab service is available for passengers who need direct transportation from Pune to Shirdi."
  },
  {
    question: "Can I book a return cab from Shirdi to Pune?",
    answer: "Yes, return and round-trip cab arrangements can be planned according to your darshan schedule and preferred return date."
  },
  {
    question: "Is same-day Pune to Shirdi cab service available?",
    answer: "Yes, a same-day return plan can be discussed depending on your preferred departure time, darshan schedule, and available travel time."
  },
  {
    question: "Is the Shirdi cab suitable for senior citizens?",
    answer: "Yes, private cab travel is a convenient option for senior devotees because it provides direct transportation and flexibility for rest breaks."
  },
  {
    question: "Can families book a private cab to Shirdi?",
    answer: "Yes, families can choose a suitable private vehicle according to their number of passengers, luggage, and comfort requirements."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I visit other religious places during the Shirdi trip?",
    answer: "Yes, additional religious or sightseeing destinations can be discussed while preparing the itinerary, depending on your available time and selected route."
  },
  {
    question: "Which vehicles are available for Pune to Shirdi travel?",
    answer: "Vehicle selection can be arranged according to passenger count, luggage, comfort preferences, and vehicle availability."
  },
  {
    question: "How can I book a Pune to Shirdi Cab?",
    answer: "Share your Pune pickup point, travel date, passenger details, preferred vehicle, and one-way or return requirement with Garud Cab Service to arrange your Shirdi cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Kulkarni",
    feedback: "We travelled from Pune to Shirdi with our parents for Sai Baba darshan. The private cab made the journey comfortable and the direct pickup was very convenient.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priyanka Jadhav",
    feedback: "Our family booked a round-trip Shirdi cab from Pune. The vehicle was comfortable and having private transportation made it easier to manage our darshan schedule.",
    rating: 5
  }
];





  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-shirdi-cab.webp",
  "description": "Book Pune to Shirdi Cab with Garud Cab for safe, comfortable, and convenient pilgrimage travel. Get one way and round trip taxi services from Pune to Shirdi with flexible cab packages and competitive fares, along with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for families, senior citizens, and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-shirdi-cab"
  }
};



  return (
    <div>



<Helmet>
  <title>Pune to Shirdi Cab | One Way Taxi & Cab Package | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Shirdi Cab with Garud Cab for comfortable and reliable pilgrimage travel. Get one way and round trip taxi services, Shirdi cab packages, and competitive fares with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to Shirdi taxi, Pune to Shirdi cab package, Pune to Shirdi cab charges, Pune to Shirdi cab fare, Pune to Shirdi cab one way, Pune to Shirdi taxi fare, Pune to Shirdi cab booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicab;